import { Component, OnInit, ViewChild } from '@angular/core';
import { Meeting } from '../../models/meeting';
import { Agent } from '../../models';
import { AgentsService } from '../../services/agents.service';
import { AgentUtility } from '../../util';
import { MeetingsService } from '../../services/meetings.service';
import { EventEmitter } from '../../../../node_modules/@types/selenium-webdriver';
import { Filter, HttpService } from "../../services";
import { EventsService, EventType, EventFilterChild } from '../../services';

@Component({
  selector: 'app-meetings',
  templateUrl: './meetings.component.html',
  styleUrls: ['./meetings.component.css'],
  providers:[MeetingsService]
})
export class MeetingsComponent implements OnInit {

  meetings:Meeting[];
  agents:any[] = [];   
  agentId: number;
  fio:string;
  filterValues: Filter = new Filter();
  filterMeetings: EventFilterChild = new EventFilterChild();


  constructor(
    private meetingsService:MeetingsService,
    private agentsService: AgentsService
  ) { }

  ngOnInit() {
    this.getMeetings();
  }

  getAgent(id) {
    this.agentsService.getAgent(id).subscribe(data => {
        let dataLoc = data.data;
        this.filterMeetings.ContractIds = dataLoc.ContactId;
        this.getMeetings();
    });

  }

  getMeetings(){
      let query1 = this.fio? this.fio.split(" ") : [];

      /**Поиск по клиенту */
      this.filterMeetings.lastName = query1[0]; 
      this.filterMeetings.firstName = query1[1];
      this.filterMeetings.middleName = query1[2];

      this.meetingsService.getMeetingsForConfirm(this.filterMeetings).subscribe(data => {
          this.meetings = data.data[0];
      
      // .sort((m1,m2) => {
      //   return (new Date(m1.Date).getTime() - new Date(m2.Date).getTime());
      // })
    })
  }

  onAgentsSelected(agents:any[]){
    this.agents = agents
    this.getMeetings();
  }

  fioFilterChange(event:KeyboardEvent){
    if(event.code == "Enter")
      this.getMeetings();
  }

  updateList(event){
    let index = this.meetings.indexOf(event);
    if(index >= 0)
      this.meetings.splice(index,1);
  }

  filter() {
    this.filterValues.page = 1;
    this.agentsService.getAgentsByFilterViews(this.filterValues).subscribe((data) => {
        this.agents = data.data;
        if(this.agents.length > 1){
          this.filterMeetings.AgentId = null;
          this.filterMeetings.ContractIds = null;
          this.filterMeetings.agents = this.agents;
          this.getMeetings();
        }
        else{
          this.getAgent(this.agents[0].Id);
        }
        
    });
  }

  clear() {
      this.filterValues = new Filter();
      this.filterMeetings = new EventFilterChild();
      this.fio = null;
      this.getMeetings();
      this.ngOnInit();
  }
    
}


